exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ntr th.half-padding[data-v-651d4cf6] {\n  padding: 4px;\n}\ntbody.loading[data-v-651d4cf6] {\n  opacity: .5;\n}\ntable th.compact[data-v-651d4cf6], table td.compact[data-v-651d4cf6] {\n  white-space: nowrap;\n  width: 1px !important;\n}\n", ""]);

// exports
